import axios from "axios";
import { GetTokenFromIndexedDB } from "../../../utils/indexedDBUtils/get-indexed-db";
import { Product } from "../../../interfaces/products/product";

const API = `${process.env.REACT_APP_API_URL}`;

const authHeaders = async () => {
  const token = await GetTokenFromIndexedDB("authToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export interface AmazonSearchItem {
  ASIN?: string;
  DetailPageURL?: string;
  Images?: { Primary?: { Medium?: { URL?: string }; Large?: { URL?: string } } };
  ItemInfo?: { Title?: { DisplayValue?: string } };
}

export interface CreateProductPayload {
  title: string;
  slug: string;
  category: string;
  subCategory: string;
  audience: "auto" | "boys" | "girls" | "both";
  description: string;
  images: string[];
  asin: string;
  amazonUrl: string;
  isDiwaliDeal: boolean;
  isTrending: boolean;
  isFeatured: boolean;
  priorityScore: number;
  isActive: boolean;
}

export const searchAmazonProducts = async (keyword: string): Promise<AmazonSearchItem[]> => {
  const headers = await authHeaders();
  const response = await axios.get(`${API}/v1/amazon/search-amazon`, { params: { keyword }, headers });
  return response.data || [];
};

export const fetchAmazonProduct = async (asin: string) => {
  const headers = await authHeaders();
  const response = await axios.get(`${API}/v1/amazon/fetch-amazon`, { params: { asin }, headers });
  return response.data;
};

export const createAdminProduct = async (payload: CreateProductPayload): Promise<Product> => {
  const headers = await authHeaders();
  const response = await axios.post(`${API}/v1/product`, payload, { headers });
  return response.data.data;
};
